<template>
  <div class="outer">
    <div :style="{ fontSize: fonts.font30 + 'px' }"
    >Statement Selection</div>
    <div class="selectBox">
      <div id="uiBox">
        <v-bar wrapper="wrapper"
               vBar=""
               vBarInternal=""
               hBar=""
               hBarInternal="">
          <div>
            <div v-for="st in statements.arr" :key="st.key">
              <div>
                <div :style="st.style" @click="clickedStMonth(st)">
                  <div class="groupSection"
                       :style="st.highlight"
                       @mouseenter="mouseEnter(st)"
                       @mouseleave="mouseExit(st)">
                    <div class="stLine" style="width: 100%" v-html="st.desc"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-bar>
        <b-button-group id="buttonGroup">
          <b-button id="btnGet"
                    @click="getStatement"
                    :class="{disabled: !enableStatement}">
            Get Statement
          </b-button>
          <b-button id="btnCan"
                    @click="cancel">
            Cancel
          </b-button>
        </b-button-group>
      </div>
    </div>
  </div>
</template>

<script>
import VBar from 'v-bar';
// eslint-disable-next-line
import utl from '../myUtils';

export default {
  components: {
    VBar,
    //
  },
  name: 'zStatement',
  data() {
    return {
      enableStatement: true, // Set to true since we are defaulting to first item selected
    };
  },
  watch: {
    stateCC() {
      // this.writeDiag('watch stateCC triggered');
      this.$forceUpdate();
    },
  },
  computed: {
    fonts() {
      return this.$store.getters.getFonts;
    },
    cun() {
      return this.$store.getters.getCuNumber;
    },
    member() {
      return this.$store.getters.getMember;
    },
    siFormUser() {
      return this.$store.getters.getSiFormUser;
    },
    navVer() {
      return this.$store.getters.getNavVer;
    },
    statements() {
      return this.$store.getters.getStatements;
    },
    stateCC() {
      return this.$store.getters.getSTcc;
    },
    webPageResponse() {
      return this.$store.getters.webPageResponse;
    },
  },
  methods: {
    clickedStMonth(st) {
      this.writeDiag(`Clicked Share history Line # ${st.key} => ${st.keyX}`);
      const stInfo = {};
      stInfo.key = st.key;
      stInfo.keyX = st.keyX;
      stInfo.style = 'background-color: blue; color: white';
      this.$store.commit('setStatementSelected', stInfo);
      this.enableStatement = true;
      this.$forceUpdate();
    },
    mouseEnter(st) {
      // this.writeDiag(`Enter Share history Line # ${st.keyX}`);
      const stInfo = {};
      stInfo.key = st.key;
      stInfo.style = 'background-color: green; color: white';
      this.$store.commit('setStatementHighlight', stInfo);
    },
    mouseExit(st) {
      // this.writeDiag(`Exit Share history Line # ${st.keyX}`);
      const stInfo = {};
      stInfo.key = st.key;
      stInfo.style = st.saveHighlight;
      this.$store.commit('clrStatementHighlight', stInfo);
    },

    getStatement() {
      if (this.enableStatement) {
        this.writeDiag('GetStatement request statement');
        const stInfo = {};
        stInfo.cun = this.cun;
        stInfo.acct = this.member.acct;
        this.$store.commit('openStatement', stInfo);
      } else {
        this.writeDiag('GetStatement button ignored');
      }
    },
    cancel() {
      this.goBack();
    },
    diag(message) {
      this.$store.commit('showDiag', message);
    },
    writeDiag(message) {
      this.$store.commit('putDiag', `stmt: ${message}`);
    },

    wsSend(rpc, myObject) {
      const data = Object.assign({}, myObject);
      data.rpcName = rpc;
      this.$store.commit('sendObjToServer', data);
    },
    goBack() {
      window.history.back();
    },
  },
};
</script>

<style scoped>
  h1 {
    font-weight: bold;
  }
  .selectBox {
    display: inline-flex;
    width: 100%;
    /* height: 300px; */
    /* border: solid 1px green; */
  }
  #uiBox {
    width: 100%;
    /* height: 376px; */
    /* border: solid 1px red; */
  }
  .wrapper {
    margin: 4px auto auto;
    height: 242px;
    width: 330px;
    border: solid 1px black;
  }
  #buttonGroup {
    position: relative;
    margin-top: 10px;
    margin-bottom: 10px;
    bottom: 0px;
    right: 0px;
    /* border: solid 1px red; */
    /* width: 50%; */
  }
  #btnGet {
    background-color: lime;
    color: black;
    font-weight: bold;
    margin-left: 5px;
    margin-right: 5px;
    /* width: 150px; */
    /* left: -10px; */
  }
  #btnCan {
    background-color: red;
    color: black;
    font-weight: bold;
    margin-left: 5px;
    margin-right: 5px;
    /* width: 100px; */
    /* right: -10px; */
  }
  .stLine {
    display: flex;
    text-wrap: avoid;
    text-align: left;
    /* vertical-align: middle;*/
    margin: auto;
    padding: 6px 0px 0px 8px;
    height: 40px;
    background-color: transparent;
    font-weight: bold;
    border: dotted 1px lightgray;
  }
  .outer {
    /* border: solid 5px blue;*/
  }

</style>



// WEBPACK FOOTER //
// src/components/selectStmt.vue